import '../../global.css'
function IntroInfo(){
  return(
    <div className="flex">
      <div className="icone">
        icone
      </div>
     <div className="info">
     <p> Somos uma empresa de transporte confiável e eficiente,
         oferecendo serviços de transporte de passageiros e mercadorias para
          atender às suas necessidades. Seja para uma viagem de lazer, uma 
          reunião de negócios ou o 
        transporte de mercadorias importantes, estamos aqui para ajudar. </p>
     </div>

    </div>
  )
}
export default IntroInfo;